import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { NavController } from '@ionic/angular';
import { OrderModel } from 'src/app/models/order.model';


const { Browser } = Plugins;


@Component({
  selector: 'basket-footer',
  templateUrl: './basket-footer.component.html',
  styleUrls: ['./basket-footer.component.scss'],
})
export class BasketFooterComponent implements OnInit {

  @Input()
  quantityProducts:any;

  @Input()
  totalAmount:any;

  @Input()
  priceCalculationStatus:any;

  @Input()
  order= <OrderModel>{};

  @Output() orderClicked = new EventEmitter();

  constructor(public nav:NavController) {
  }

  ngOnInit(){
  }

  onOrderClicked(){
    this.orderClicked.emit();
  }
  
}
